import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_056.jpg';
page.rectangle = [
  {
    id: 'page056_rectST0',
    linked: [],
    activeIndex: 54,

    x: 129,
    y: 1653,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST1',
    linked: [],
    activeIndex: 52,

    x: 129,
    y: 1601,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST2',
    linked: [],
    activeIndex: 50,

    x: 129,
    y: 1550,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST3',
    linked: [],
    activeIndex: 48,

    x: 129,
    y: 1499,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST4',
    linked: [],
    activeIndex: 46,

    x: 129,
    y: 1448,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST5',
    linked: [],
    activeIndex: 44,

    x: 129,
    y: 1395,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST6',
    linked: [],
    activeIndex: 42,

    x: 129,
    y: 1344,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST7',
    linked: [],
    activeIndex: 40,

    x: 129,
    y: 1291,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST8',
    linked: [],
    activeIndex: 38,

    x: 129,
    y: 1239,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST9',
    linked: [],
    activeIndex: 36,

    x: 129,
    y: 1188,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST10',
    linked: [],
    activeIndex: 34,

    x: 129,
    y: 1135,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST11',
    linked: [],
    activeIndex: 32,

    x: 129,
    y: 1083,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST12',
    linked: [],
    activeIndex: 30,

    x: 129,
    y: 1031,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST13',
    linked: [],
    activeIndex: 28,

    x: 129,
    y: 979,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST14',
    linked: [],
    activeIndex: 26,

    x: 129,
    y: 925,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST15',
    linked: [],
    activeIndex: 24,

    x: 129,
    y: 875,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST16',
    linked: [],
    activeIndex: 22,

    x: 129,
    y: 823,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST17',
    linked: [],
    activeIndex: 20,

    x: 129,
    y: 767,
    width: 885,
    height: 55,
  },
  {
    id: 'page056_rectST18',
    linked: [],
    activeIndex: 18,

    x: 129,
    y: 716,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST19',
    linked: [],
    activeIndex: 16,

    x: 129,
    y: 666,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST20',
    linked: [],
    activeIndex: 14,

    x: 129,
    y: 613,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST21',
    linked: [],
    activeIndex: 12,

    x: 129,
    y: 559,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST22',
    linked: [],
    activeIndex: 10,

    x: 129,
    y: 509,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST23',
    linked: [],
    activeIndex: 8,

    x: 129,
    y: 458,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST24',
    linked: [],
    activeIndex: 6,

    x: 129,
    y: 406,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST25',
    linked: [],
    activeIndex: 4,

    x: 129,
    y: 354,
    width: 885,
    height: 50,
  },
  {
    id: 'page056_rectST26',
    linked: [],
    activeIndex: 2,

    x: 129,
    y: 301,
    width: 885,
    height: 50,
  },
];
export default page;
